export default __webpack_public_path__ + "static/media/questionSound.722abaf9.mp3";